import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13f846b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13f846b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f846b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f846b4')) {
      api.createRecord('13f846b4', component.options)
    } else {
      api.reload('13f846b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13f846b4&scoped=true", function () {
      api.rerender('13f846b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformManage/staff/index.vue"
export default component.exports